import { Checkbox } from "components/Form/Checkbox";
import { useCallClientNumbers } from "hooks/fetch/useCallClientNumbers";
import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { FormRow } from "styles/FormRow";
import { InputGroup } from "styles/InputGroup";
import { CustomTextarea } from "./styles";
import { ClosingMessageProps } from "./types";

const DEFAULT_CLOSING_MESSAGE = 'Estamos encerrando este atendimento por aqui.\n\nReforçamos que este número foi usado apenas temporariamente para não deixar seu atendimento parado. Caso precise falar conosco novamente, por favor, utilize nosso canal oficial que segue abaixo.\n\nAgradecemos o contato!';

export function ClosingMessage({ session }: ClosingMessageProps) {
  const { control, setValue, formState } = useFormContext();
  const { data: numbers } = useCallClientNumbers();

  const selectedNumber = numbers?.find(number => number.number_id === session);
  const isCloud = !selectedNumber || selectedNumber.provider === 'whatsapp-cloud';

  const sendClosingMessage = useWatch({ name: 'send_closing_message', control });

  useEffect(() => {
    if (isCloud) return;

    setValue('send_closing_message', true);

    if (!formState.dirtyFields.closing_message) {
      setValue('closing_message', DEFAULT_CLOSING_MESSAGE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCloud]);

  if (isCloud) return null;

  return (
    <>
      <FormRow>
        <InputGroup flexItem>
          <Checkbox
            name="send_closing_message"
            control={control}
            id="send_closing_message"
            label="Enviar mensagem de encerramento"
          />
        </InputGroup>
        {sendClosingMessage && (
          <InputGroup flexItem>
            <Checkbox
              name="send_attendance_contact"
              control={control}
              id="send_attendance_contact"
              label="Enviar contato do atendimento"
            />
          </InputGroup>
        )}
      </FormRow>
      {sendClosingMessage && (
        <InputGroup>
          <CustomTextarea
            name="closing_message"
            control={control}
            id="closing_message"
            fullwidth
          />
        </InputGroup>
      )}
    </>
  );
}
